// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__26fcT","checkboxCol":"Table_checkboxCol__JN4Hm","emailCol":"Table_emailCol__-G_na","actionCol":"Table_actionCol__2aFVy"};